export default __webpack_public_path__ + "static/media/767.b948c7c4.png";